
import { Constants } from './constants';
import { UserDTO } from '../model/UserDTO';

export class Utils {
    private static ROLES = Constants.ROLES

    public static dateToString(date: Date): string {
        let dateObj = {
            year: date.getUTCFullYear(),
            month: date.getUTCMonth() + 1,
            day: date.getUTCDate()
        }
        let dateStr = "";
        if (dateObj.day < 10) {
            dateStr += '0' + dateObj.day;
        } else {
            dateStr += dateObj.day;
        }
        dateStr += '/'
        if (dateObj.month < 10) {
            dateStr += '0' + dateObj.month;
        } else {
            dateStr += dateObj.month;
        }
        dateStr += '/' + dateObj.year;

        return dateStr;
    }

    public static getRolesCanCreateByRol(rol: string, forceAll: boolean): any[] {
        let listRol = [];
        switch (rol) {
            case 'SUPERADMIN':
                listRol = [this.ROLES.SUPERADMIN, this.ROLES.ADMIN, this.ROLES.LEADER, this.ROLES.COLLABORATOR];
                break;
            case 'ADMIN':
                listRol = [this.ROLES.ADMIN, this.ROLES.LEADER, this.ROLES.COLLABORATOR];
                break;
            case 'LEADER':
                if (forceAll)
                    listRol = [this.ROLES.ADMIN, this.ROLES.LEADER, this.ROLES.COLLABORATOR];
                else
                    listRol = [this.ROLES.COLLABORATOR];
                break;
            case 'COLLABORATOR':
                listRol = [];
                break;
            default:
                break;
        }
        // Return a clone
        return JSON.parse(JSON.stringify(listRol));
    }

    public static userHavePermissions(user: UserDTO, roles: any[], mustHaveClient: boolean) {
        if (user) {
            let item = roles.find(x => { return x.NAME == user.role });
            if (item) {
                if (mustHaveClient) {
                    if (user.clientID) {
                        return true;
                    }
                } else {
                    return true;
                }
            }
        }
        return false;
    }

    public static capitalizeEveryWord(str: string) {
        var splitStr = str.toLowerCase().split(' ');
        let returnString = '';
        for (var i = 0; i < splitStr.length; i++) {
            returnString += splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1) + ' ';
        }
        return returnString.trim();
    }

    public static getColorKeyDriver(isNPS: boolean, value: number): string {
        if (!isNPS && value == 0)
            return 'rgb(236, 239, 241)'
        if ((!isNPS && value < 5) || (isNPS && value <= -50)) {
            return '#FF7875';
        }
        if ((!isNPS && value < 7) || (isNPS && value <= 0)) {
            return 'rgba(255, 251, 143, 0.9)';
        }
        if ((!isNPS && value < 9) || (isNPS && value <= 50)) {
            return 'rgba(217, 247, 190, 0.8)';
        }
        return 'rgba(160, 218, 169, 0.8)';
    }

    public static getLeyendForKeyDrivers(isNPS: boolean, score: string): string {
        switch (score) {
            case 'low':
                return isNPS ? 'LOW-NPS' : 'LOW';
            case 'good':
                return isNPS ? 'GOOD-NPS' : 'GOOD';
            case 'very-good':
                return isNPS ? 'VERY-GOOD-NPS' : 'VERY-GOOD';
            case 'excelent':
                return isNPS ? 'EXCELENT-NPS' : 'EXCELENT';
        }
    }

    public static getUserSilhouette(): string {
        return 'assets/custom/images/user_silueta.jpg';
    }



    public static copyToClipboard(text) {
        let windowCopy: any = window;
        if (windowCopy.clipboardData && windowCopy.clipboardData.setData) {
            // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
            return windowCopy.clipboardData.setData("Text", text);
        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            }
            catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            }
            finally {
                document.body.removeChild(textarea);
            }
        }
    }
}